/**
 * Today as a YYYY-MM-DD string in the user's local calendar, not UTC. Date
 * fields compare "today or later" bounds against the day the filler is in;
 * an ISO-string slice would be yesterday in Melbourne every morning.
 */
export const localIsoDate = (d: Date = new Date()): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
